/**
 * 与えられた文字列内に URL またはドメイン名が含まれているかどうかを判定します。
 *
 * @param text - チェックする文字列
 * @returns 文字列内に URL またはドメイン名が含まれている場合は true、そうでない場合は false
 *
 * @example
 * // 以下は true を返します
 * containsUrlOrDomain("Visit our website at https://example.com");
 * containsUrlOrDomain("Our domain is example.com");
 *
 * // 以下は false を返します
 * containsUrlOrDomain("This is a regular sentence.");
 */
export const containsUrlOrDomain = (text: string): boolean => {
  // URL または ドメイン名のパターンを定義
  const urlPattern =
    /^\[?(https?:\/\/)?([\da-z][\da-z-]*[\da-z]*\.)+[a-z]{2,}[#/?]?[\w\*-\._]*]?$/i

  // 文字列内の単語を空白で分割
  const words = text.split(/\s+/)

  // 各単語が URL またはドメイン名のパターンにマッチするか確認
  return words.some((word) => urlPattern.test(word))
}
